// extracted by mini-css-extract-plugin
export default {"content":"ViewMyMessages_content__UQXst"};